import React from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import { Typography, Grid, Paper } from "@material-ui/core";
import moment from "moment";
import { useStore } from "../../../store";
import { EodReportTables } from "./EodReportTables";
import logo from "../../../assets/images/webappLogo.jpg";

export const FinancialReport = React.forwardRef(
  (
    eodReportDetails: {
      eodId: number;
      [key: string]: any;
      userData: any;
      detailFlag: boolean;
    },
    ref: any
  ) => {
    const [user] = useStore("auth", "user");
    const classes = financialItemStyles();
    const eodTableList = EodReportTables(eodReportDetails, "print");
    return (
      <Paper className={classes.paper} ref={ref} elevation={0}>
        <Grid
          container
          spacing={3}
          direction="row"
          // alignItems="center"
          // justify="center"
          style={{ display: "block" }}
        >
          {/* header */}
          <div style={{ paddingBottom: "3.5em" }}>
            <Grid item lg>
              <Grid container justify="space-evenly" alignItems="center">
                <Grid item>
                  <img src={logo} alt="Logo" height={110} width={290} />
                </Grid>
                <Grid item>
                  <Typography className={classes.report}>
                    Financial Report
                  </Typography>
                  <Typography className={classes.description}>
                    Document No:{" "}
                    {eodReportDetails.eodReportDetails
                      .eod_businessday_doc_num === undefined
                      ? eodReportDetails.eodReportDetails.eod_businessdayid
                      : eodReportDetails.eodReportDetails
                          .eod_businessday_doc_num}
                  </Typography>
                  <Typography className={classes.description}>
                    {eodReportDetails.detailFlag === true
                      ? eodReportDetails.userData.store_name
                      : `Branch:  ${user.store_name}`}
                  </Typography>
                  <Typography className={classes.description}>
                    Date :{" "}
                    {moment(
                      eodReportDetails.eodReportDetails.bod_datetime
                    ).format("YYYY-MM-DD HH:MM:SS")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </div>

          {/* header */}

          <Grid item lg={12}>
            <Grid container justify="center" alignItems="center">
              <Grid item lg={12}>
                <table>
                  <thead>
                    <tr>
                      <td>
                        <div className={classes.headerspace}>&nbsp;</div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className={classes.content}>
                          {eodTableList &&
                            eodTableList.map((t, i) => (
                              <Grid container key={i + 1}>
                                <Grid item lg={12}>
                                  {t.table}
                                  
                                </Grid>
                              </Grid>
                            ))}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <div className={classes.footerspace}>&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </Grid>
            </Grid>

            {/* <footer> */}
            <div className="footer">
              <Grid item xs={12} style={{ paddingTop: "2em" }}>
                <Grid
                  container
                  className={classes.titlegap}
                  alignItems="center"
                  justify="space-between"
                >
                  <Grid item xs={6}>
                    <Typography className={classes.printLeftDetail}>
                      Printed on{" "}
                      {moment(new Date()).format("dddd DD-MMM-YYYY HH:MM:SS")}
                    </Typography>
                    {/* <Typography>Terminal:10.10.2.25</Typography> */}
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.printRightDetail}>
                      {`Printed by: ${user.full_name}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </div>

            {/* </footer> */}
          </Grid>
        </Grid>
      </Paper>
    );
  }
);
